import { ANOMALY, PAUSE_REQUEST, TECHNICAL_GUIDE_STATE } from "./constants";

type Anomaly = (typeof ANOMALY)[keyof typeof ANOMALY];
type TechnicalGuideState = (typeof TECHNICAL_GUIDE_STATE)[keyof typeof TECHNICAL_GUIDE_STATE];
type PauseRequest = (typeof PAUSE_REQUEST)[keyof typeof PAUSE_REQUEST];

export interface RequestData {
    // token: string; // the token is added by the request function
    callId: string;
    anomaly?: Anomaly;
    technicalGuideState: TechnicalGuideState;
    pauseRequest: PauseRequest;
    comment: string | null;
}

export interface Answers {
    anomaly?: Anomaly;
    technicalGuideLinked?: string;
    technicalGuideHelpful?: string;
    pauseRequest?: string;
    pauseRequestDuration?: string;
    comment?: string;
}

export interface QuestionsObject {
    [key: string]: Question;
}

export interface Question {
    name: string;
    labelKey: string;
    options: Options;
    comment?: Comment;
    invisible?: boolean;
}

export interface Comment {
    name: string;
    labelKey: string;
    placeholderKey: string;
}

interface Options {
    [key: string]: Option;
}

export interface Option {
    labelKey: string;
    next?: string;
}
